import React from "react";
import Image from "./elements/Image";
import { ArrowUpTrayIcon, XMarkIcon } from "@heroicons/react/24/outline";

const AddToHomeScreen = ({ workspaceDetails, site, onClose = () => {} }) => {
  const workspaceImage = workspaceDetails.square_logo || workspaceDetails.image_logo || workspaceDetails.image_favicon || site?.image_logo;

  return (
    <div className="relative flex h-[250px] flex-col items-center justify-center gap-8 text-center">
      <div className="absolute -right-4 -top-4 z-10">
        <button
          type="button"
          version="default"
          onClick={onClose}
          className="text-gray-400 hover:text-gray-500">
          <XMarkIcon
            className="h-8 w-8"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="inline-flex h-20 w-auto overflow-hidden rounded-xl border border-gray-100">
        <Image
          src={workspaceImage}
          classes="h-full w-full object-contain"
        />
      </div>
      <div className="space-y-3">
        <div className="text-xl font-bold">Add to Home Screen for mobile</div>
        <div className="text-base font-medium">Doing this from Safari’s share menu is required for the best experience</div>
        <div className="text-base font-medium">
          Tap{" "}
          <span className="mx-1 inline-flex w-6 translate-y-2">
            <ArrowUpTrayIcon className="h-6 w-6" />
          </span>{" "}
          then "Add to Home Screen"
        </div>
      </div>
    </div>
  );
};

export default AddToHomeScreen;
